<template>
  <div class="input-wrapper">
    <slot />
  </div>
</template>
<script>
export default {
  name: 'WrappedInput',
  props: {
    hideDetails: {
      type: Boolean,
      default: true,
    },
  },
  created() {
    this.setProps()
  },
  beforeUpdate() {
    this.setProps()
  },
  methods: {
    setProps() {
      if (this.hideDetails) {
        this.$slots.default.forEach((item) => {
          if (!item.componentOptions) return
          const { errorMessages } = item.componentOptions?.propsData
          item.componentOptions.propsData.hideDetails = Boolean(!errorMessages?.length)
        })
      }
    },
  },
}
</script>
<style lang="scss">
  .input-wrapper {
    position: relative;
    margin-bottom: 1.5rem;
    .v-text-field__details {
      position: absolute;
      bottom: -1.8rem;
    }
  }
</style>
